module.exports = __webpack_public_path__ + "img/Pot3.68388885.svg";